export default Object.freeze({
  /**
   * `GET time-entries/status` error
   */
  status: 'status',
  /**
   * `GET time-entries/bookings` error
   */
  bookings: 'bookings',
  /**
   * `POST time-entries/clock-in` error
   */
  clockIn: 'clockIn',
  /**
   * `POST time-entries/clock-out` error
   */
  clockOut: 'clockOut',
  /**
   * `POST time-entries/meal-break-start` error
   */
  mealBreakStart: 'mealBreak.start',
  /**
   * `POST time-entries/meal-break-end` error
   */
  mealBreakEnd: 'mealBreak.end',
  /**
   * `GET time-entries/meal-break/status` error
   */
  mealBreakStatus: 'mealBreak.status',
})
